import { DEFAULT_THEME_COLOR, normalizeThemeColor } from '../config/themeColors';

let accentColor = DEFAULT_THEME_COLOR;

export function setAccentColor(color) {
  accentColor = normalizeThemeColor(color);
}

export function getAccentColor() {
  return accentColor;
}

/** Nuance CSS Mantine (0–9) pour la palette thème active. */
export function colorVar(shade, color = getAccentColor()) {
  return `var(--mantine-color-${color}-${shade})`;
}

/** @deprecated utiliser colorVar */
export function primaryVar(shade) {
  return colorVar(shade);
}
